import { useState, useEffect, useRef } from 'react';

export default function FormularioDepoimento() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [depoimento, setDepoimento] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Lógica de envio do formulário
    console.log({ nome, email, depoimento });
  };

  return (
    <section ref={sectionRef} className="pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-amber-500/20 rounded-3xl p-12">
          {/* Header */}
          <div className="text-center mb-10">
            <div 
              className={`inline-flex items-center gap-2 px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full mb-6 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <i className="ri-edit-line text-amber-400"></i>
              <span className="text-amber-400 text-sm font-medium">Compartilhe Sua História</span>
            </div>
            
            <h2 
              className={`text-3xl md:text-4xl font-bold text-white mb-4 transition-all duration-700 delay-100 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Inspire Outras Pessoas
            </h2>
            
            <p 
              className={`text-slate-300 text-lg transition-all duration-700 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Sua jornada de transformação pode motivar alguém a começar a sua
            </p>
          </div>

          {/* Formulário */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div 
              className={`transition-all duration-700 delay-300 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <label htmlFor="nome" className="block text-white font-medium mb-2 text-sm">
                Nome Completo
              </label>
              <input
                type="text"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                className="w-full px-4 py-3 bg-slate-950/50 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:border-amber-500/50 focus:outline-none focus:ring-2 focus:ring-amber-500/20 transition-all text-sm"
                placeholder="Seu nome"
                required
              />
            </div>

            <div 
              className={`transition-all duration-700 delay-400 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <label htmlFor="email" className="block text-white font-medium mb-2 text-sm">
                E-mail
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-slate-950/50 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:border-amber-500/50 focus:outline-none focus:ring-2 focus:ring-amber-500/20 transition-all text-sm"
                placeholder="seu@email.com"
                required
              />
            </div>

            <div 
              className={`transition-all duration-700 delay-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <label htmlFor="depoimento" className="block text-white font-medium mb-2 text-sm">
                Seu Depoimento
              </label>
              <textarea
                id="depoimento"
                value={depoimento}
                onChange={(e) => setDepoimento(e.target.value)}
                rows={6}
                className="w-full px-4 py-3 bg-slate-950/50 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:border-amber-500/50 focus:outline-none focus:ring-2 focus:ring-amber-500/20 transition-all resize-none text-sm"
                placeholder="Conte sua história de transformação..."
                required
              />
            </div>

            <button
              type="submit"
              className={`w-full px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-slate-950 rounded-xl font-bold text-lg hover:shadow-2xl hover:shadow-amber-500/30 transition-all duration-700 delay-600 whitespace-nowrap ${
                isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
              } hover:scale-105`}
            >
              Enviar Depoimento
            </button>
          </form>

          {/* Trust Message */}
          <p 
            className={`text-center text-slate-400 text-sm mt-6 transition-all duration-700 delay-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <i className="ri-lock-line text-amber-400 mr-2"></i>
            Seus dados estão seguros e serão usados apenas para publicação do depoimento
          </p>
        </div>
      </div>
    </section>
  );
}
